const Help = () => (
  <div>TODO: help</div>
);

export default Help;
